/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    addButton: {
        label: "Add"
    },
    cancelButton: {
        label: "Cancel"
    },
    closeButton: {
        label: "Close"
    },
    confirmButton: {
        label: "Confirm"
    },
    deleteButton: {
        label: "Delete"
    },
    noButton: {
        label: "No"
    },
    okButton: {
        label: "Ok"
    },
    saveButton: {
        label: "Save"
    },
    toggleVisibility: {
        hide: "Hide content",
        show: "Show content"
    },
    yesButton: {
        label: "Yes"
    }
};